import { useState, useEffect } from "react";
import { Cookie } from "lucide-react";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const ok = localStorage.getItem("medas_cookie_consent");
    if (!ok) setTimeout(() => setVisible(true), 1200);
  }, []);

  const accept = (level) => {
    localStorage.setItem("medas_cookie_consent", level);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 lg:bottom-4 left-0 lg:left-4 right-0 lg:right-auto z-[60] lg:max-w-md mb-20 lg:mb-0" data-testid="cookie-consent-banner">
      <div className="mx-3 lg:mx-0 bg-white rounded-2xl shadow-2xl border border-slate-200 p-5">
        <div className="flex items-start gap-3">
          <span className="w-10 h-10 rounded-xl bg-[#EFE7D6] flex items-center justify-center shrink-0">
            <Cookie className="w-5 h-5 text-[#A6823B]" />
          </span>
          <div>
            <h4 className="font-display font-bold text-slate-900 text-base">Confidențialitatea ta contează</h4>
            <p className="text-sm text-slate-600 mt-1 leading-relaxed">
              Folosim cookie-uri pentru a îmbunătăți experiența pe site, conform GDPR.
              Poți accepta toate cookie-urile sau doar pe cele esențiale.
            </p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 mt-4">
          <button onClick={() => accept("all")} data-testid="cookie-consent-accept-button"
            className="flex-1 bg-[#A6823B] hover:bg-[#8A6B2E] text-white text-sm font-semibold px-4 py-2.5 rounded-full transition-colors">
            Acceptă toate
          </button>
          <button onClick={() => accept("essential")} data-testid="cookie-consent-essential-button"
            className="flex-1 bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-semibold px-4 py-2.5 rounded-full transition-colors">
            Doar esențiale
          </button>
        </div>
      </div>
    </div>
  );
}
